import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;
export const consultarAssinante = (cpf) =>
    axios.get(`${baseURL}/retirada/assinante/${cpf}`);
export const confirmarRetirada = (data) =>
    axios.post(`${baseURL}/retirada`, data);
export const getPontosTroca = () =>
    axios.get(`${baseURL}/retirada/pontos-troca`);
export const getPromocaoUsuario = (cpf) =>
    axios.get(`${baseURL}/retirada/promocoes/${cpf}`);
